import { ReactNode } from 'react'
import { PageHeaderShell, PageHeaderTitle } from '@musinsa/pbo-core'

interface PageHeaderProps {
  title?: ReactNode
}

export function PageHeader({ title }: Readonly<PageHeaderProps>) {
  return <PageHeaderShell titleArea={<PageHeaderTitle title={title} />} />
}

export default PageHeader
